import React from "react";
import { Tooltip, Button, ButtonProps } from "@mui/material";

export type DisableableButtonProps = ButtonProps & { disabledTooltip: React.ReactNode };
export const DisableableButton = ({ disabledTooltip, ...buttonProps }: DisableableButtonProps) => {
  return (
    <Disableable disabledTooltip={disabledTooltip} disabled={buttonProps.disabled ?? false}>
      <Button {...buttonProps} />
    </Disableable>
  );
};

interface DisableableProps {
  disabledTooltip: React.ReactNode;
  disabled: boolean;
  children: React.ReactNode;
  isBlock?: boolean;
  /** Use when inside a modal - pass a value higher than the modal's z-index (e.g. 16000) */
  tooltipZIndex?: number;
}

export const Disableable = ({
  disabledTooltip,
  disabled,
  children,
  isBlock = false,
  tooltipZIndex,
}: DisableableProps) => {
  if (disabled && disabledTooltip) {
    return (
      <Tooltip
        title={disabledTooltip}
        PopperProps={tooltipZIndex != null ? { style: { zIndex: tooltipZIndex } } : undefined}
      >
        {isBlock ? <span>{children}</span> : <div>{children}</div>}
      </Tooltip>
    );
  } else {
    return <>{children}</>;
  }
};
